import { render } from "./IsoVoyageMalysia.vue?vue&type=template&id=d7e8444c"
import script from "./IsoVoyageMalysia.vue?vue&type=script&lang=js"
export * from "./IsoVoyageMalysia.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__